import { Minus, Plus } from "lucide-react";

/**
 * Number stepper with +/- buttons and a read-only middle value.
 * Replaces <input type="number"> which had a UX bug where typing while
 * the field had an existing default value (e.g. 2) appended digits → "23".
 */
export default function NumberStepper({
  value,
  onChange,
  min = 0,
  max = 99,
  label,
  testid,
}) {
  const dec = () => onChange(Math.max(min, value - 1));
  const inc = () => onChange(Math.min(max, value + 1));
  return (
    <div className="flex items-stretch gap-2 bg-white border border-[#E9E2D3] rounded-xl overflow-hidden">
      <button
        type="button"
        onClick={dec}
        disabled={value <= min}
        aria-label={`Decrease ${label || "value"}`}
        data-testid={testid ? `${testid}-dec` : undefined}
        className="w-12 sm:w-14 flex items-center justify-center text-[#1A2B4C] hover:bg-[#F5F2EB] disabled:opacity-30 disabled:cursor-not-allowed transition-colors active:scale-95"
      >
        <Minus className="w-4 h-4" />
      </button>
      <div
        data-testid={testid}
        className="flex-1 flex items-center justify-center text-lg font-medium text-[#1A2B4C] tabular-nums select-none"
        aria-live="polite"
      >
        {value}
      </div>
      <button
        type="button"
        onClick={inc}
        disabled={value >= max}
        aria-label={`Increase ${label || "value"}`}
        data-testid={testid ? `${testid}-inc` : undefined}
        className="w-12 sm:w-14 flex items-center justify-center text-[#1A2B4C] hover:bg-[#F5F2EB] disabled:opacity-30 disabled:cursor-not-allowed transition-colors active:scale-95"
      >
        <Plus className="w-4 h-4" />
      </button>
    </div>
  );
}
